import React from 'react';
import { MdContentCopy } from 'react-icons/md';

import { Item, Container, Image, Header, Link, Name, Size, Type, LinkWrapper } from './style';

const ListItem = ({file}) => {

  const copyLinkToCpliboard = (link) => navigator.clipboard.writeText(link);

  return (
    <Item>
      <Image src={file?.link} alt="" />
      <Container>
        <Header>
          <Name>{file?.name}</Name>
          <p>
            <Size>Size: {file?.size}</Size>
            <Type>Type: {file?.type}</Type>
          </p>
        </Header>
        <LinkWrapper>
          <Link href={file?.link} target="_blank" rel="noopener noreferer">
            {file?.link}
          </Link>

          <MdContentCopy
            onClick={() => copyLinkToCpliboard(file?.link)}
            title="Click to copy"
            style={{ cursor: 'pointer', fontSize: '20px', color: '#666' }}
          />

        </LinkWrapper>
      </Container>
    </Item>
  );
};

export default ListItem;
